import { Card, Table, Button } from 'react-bootstrap';

const coupons = [
  { id: 'C10', code: 'WELCOME10', discount: '10%', type: 'percent', expiresAt: '2025-03-01' },
  { id: 'CFREE', code: 'FREESHIP', discount: '$0', type: 'fixed', expiresAt: '2025-02-15' },
];

export default function Coupons() {
  return (
    <Card className="shadow-sm">
      <Card.Body>
        <div className="d-flex justify-content-between align-items-center mb-3">
          <Card.Title>Coupons</Card.Title>
          <Button size="sm">Create Coupon</Button>
        </div>
        <Table hover responsive>
          <thead>
            <tr>
              <th>Code</th>
              <th>Discount</th>
              <th>Type</th>
              <th>Expires</th>
            </tr>
          </thead>
          <tbody>
            {coupons.map((coupon) => (
              <tr key={coupon.id}>
                <td>{coupon.code}</td>
                <td>{coupon.discount}</td>
                <td>{coupon.type}</td>
                <td>{coupon.expiresAt}</td>
              </tr>
            ))}
          </tbody>
        </Table>
      </Card.Body>
    </Card>
  );
}

